// Do NOT add "use client" to this file
import { Action, Core } from "@faire/slate/foundation/color";
import { Column } from "@faire/web/slate/Layout";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

export const ImageOverlay = ({
  formattedExtraProductsCount,
  smallCount,
}: {
  formattedExtraProductsCount?: string;
  smallCount?: boolean;
}) => {
  return (
    <>
      {formattedExtraProductsCount ? (
        <Column
          align="center"
          justify="center"
          className="bg-core-surface-default/50 p-2x rounded-fs-component-default absolute top-0 right-0 bottom-0 left-0"
        >
          <Typography
            variant={
              smallCount ? "paragraphSansMedium" : "sectionHeaderSansMedium"
            }
            color={Core.text.primaryInverse}
            align="center"
          >
            <StrictLocalMsg
              id="IlbPF7"
              defaultMessage="+{countNumber}"
              description={{
                text: "A counter showing the number of extra products in a list",
                img: "https://cdn.faire.com/fastly/f037b34cba4e7fac281649303451bc64211498377b9db0c3076da1479e8d3daa.png",
              }}
              values={{ countNumber: formattedExtraProductsCount }}
            />
          </Typography>
        </Column>
      ) : (
        <div
          className="rounded-fs-component-default pointer-events-none absolute top-0 left-0 z-2 h-full w-full print:hidden"
          style={{ background: `${Action.surface.active}05` }}
        />
      )}
    </>
  );
};
